import React from "react";
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

type Option = {
  value: string;
  label: string;
};

type Props = {
  label: string;
  options: Option[];
  value: string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
};

const CustomCheckboxes: React.FC<Props> = ({
  label,
  options,
  value,
  onChange,
  disabled,
}) => {
  const handleCheckboxChange =
    (optionValue: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      let newSelected: string[];
      if (checked) {
        newSelected = [...value, optionValue];
      } else {
        newSelected = value.filter((v) => v !== optionValue);
      }
      onChange(newSelected);
    };

  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                checked={value.includes(option.value)}
                onChange={handleCheckboxChange(option.value)}
                disabled={disabled}
              />
            }
            label={option.label}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default CustomCheckboxes;
